<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import MaterialRiskEditor from '../Element/MaterialRiskEditor.svelte';
    import {draftElementDetails, elementInstance, elementDetails, standaloneEdit} from './workspacesStore.js';
    import {get} from '../../utils.js';
    let draftAvailable = false;
    let isSafetyElement = false;

    $: if ($elementInstance && $elementInstance.id) {
        if ($elementInstance.versions) {
            draftAvailable = $elementInstance.versions.some(v => v.status === 'DRAFT');
        }
        isSafetyElement = $elementDetails.type === 'SAFETY';
    } else if ($standaloneEdit) {
        draftAvailable = $draftElementDetails != null;
        isSafetyElement = $elementDetails.type === 'SAFETY';
    }

    $: mechanismListPlacement = $standaloneEdit ? 'auto' : 'absolute-bottom-right';
    $: mechanismListAbsoluteParentId = $standaloneEdit ? undefined : 'left-right-layout';
    $: mechanismListAbsoluteScrollParentSelector = $standaloneEdit ? undefined : '.tab-content';

    let draftElementVersionViewApiUrl = `${PATH_PREFIX}/sw/api/elements_database/draft_element_version/`;


    async function getElementVersionDetails(){
        const elementId = $elementDetails ? $elementDetails.elementId : 0;
        if(elementId) {
            const resp = await get(`${draftElementVersionViewApiUrl}${elementId}/`);

            let details = {};

            if (resp.ok) {
                const json = await resp.json();
                details = json;
                details.competencies = json.competencies.map(c => ({id: c.competency, name: c.name}));
                draftElementDetails.set(details);
            }
        }
    }

    onMount(async () => {
        await getElementVersionDetails();
    });
</script>


{#if draftAvailable && isSafetyElement}
    <MaterialRiskEditor
        {mechanismListPlacement}
        {mechanismListAbsoluteParentId}
        {mechanismListAbsoluteScrollParentSelector}
    />
{/if}
